import {useState, useEffect} from "react";
import {AvailableAppResponse} from "../logic/APITypes";
import API from "../logic/API";
import {Resolution} from "../logic/FetchResolver";

/** A hook for fetching all available apps from the API */
function useAvailableApps(groupId: string) {
  const [availableApps, setAvailableApps] = useState<AvailableAppResponse[]>(
    [],
  );
  const [loading, setLoading] = useState(true);
  const getAvailableApps = async () => {
    setLoading(true);
    const res: Resolution<AvailableAppResponse[]> =
      await API.getAvailableApps(groupId);
    setLoading(false);
    if (res.success && res.payload) {
      const apps = res.payload.map((app) => {
        return {...app, logo: "data:image/svg+xml;base64," + app.logo};
      });
      setAvailableApps(apps);
    }
  };

  useEffect(() => {
    getAvailableApps();
  }, []);
  return {availableApps, loading};
}

export default useAvailableApps;
